<script lang="ts" setup>
import { toRef } from 'vue'
import _ from 'lodash'

export type Locale = {
  code: string,
  code_i18n: string
}

export type Title = {
  text: string | null,
  locale: string | null,
  component_id: number
}

const props = defineProps<{
  locales: Locale[],
  title: Title
  index: number,
  // errors: TitleError | undefined
}>()

const emit = defineEmits(['update:title', 'delete-title', 'delete-title-error'])
const title = toRef(props, 'title')

const { locales } = props

const deleteTitle = () => {
  emit('delete-title', title.value.component_id)
}

const updateLanguageId = (e: Event) => {
  const target = e.target as HTMLInputElement
  emit('update:title', {
    ...title.value,
    locale: target.value
  })
}

const updateText = (e: Event) => {
  const target = e.target as HTMLInputElement
  emit('update:title', {
    ...title.value,
    text: target.value
  })
}

</script>

<template lang="pug">
div.games__modal-basic-item
  select(
    class="uk-select games__modal-basic-language"
    :value="title.locale"
    @change="updateLanguageId"
    :id="`title_locale_${title.component_id}`"
  )
    option(v-for="locale in locales" :value="locale.code")
      | {{ locale.code_i18n }}
  input(
    type="text"
    class="uk-input games__modal-basic-title"
    :value="title.text"
    @change="updateText"
    :id="`title_text_id_${title.component_id}`"
  )
  div.games__modal-basic-remove(v-if="props.index !== 0" @click="deleteTitle")
    fa(icon="trash-can")
//- div.account__form-value-error(v-if="errors")
//-   | {{ errors.text}}
//-   | {{ errors.locale}}
</template>
